const flattenObject = (obj, prefix = "") =>
  Object.keys(obj).reduce((flattenedObj, key) => {
    const flattenedKey = prefix.length ? `${prefix}.` : "";

    if (typeof obj[key] === "object") {
      Object.assign(flattenedObj, flattenObject(obj[key], flattenedKey + key));
    } else {
      // eslint-disable-next-line no-param-reassign
      flattenedObj[flattenedKey + key] = obj[key];
    }

    return flattenedObj;
  }, {});

export default flattenObject;
